<script>

import ratingAndComment from './subcomponents/ratingAndComment.vue'
import commentWithTools from './subcomponents/commentWithTools.vue'

import {useVuelidate} from '@vuelidate/core'
import {required, requiredIf, helpers} from '@vuelidate/validators'

import {api as viewerApi} from "v-viewer"

export default {
  inject: ['$Q', '$DateTime', '$axios', '$_', '$ApexCharts'],
  setup() {
    return {v$: useVuelidate()}
  },
  props: {
    profileID: String,
    loginData: Object,
    dataFrom: String,
    profileApproving: Boolean
  },
  data() {
    return {
      profileSubmittedMsg: '',
      showFundPositionChart: false,
      showLoadingAnimation: false,
      approvalRemarksPlaceHolder: '',
      profileSubmitted: false,
      currentData: {},
      profileLoading: true,
      profileLoadingText: 'Retrieving Profile data',
      activeProfile: {},
      faceImages: [],
      conditionImages: [],
      waiverImages: [],
      identificationImages: [],
      additionalFiles: [],
      feedbackViewBtn: '',
      profileTS: '',
      profileComment: '',
      profilePartner: '',
      profileApproval: {
        status: '',
        reason: '',
        fundingPocket: '',
        fundingPocketWatsi: '',
        fundingPocketFundManagerApproved: '',
        tagForFuture: ''
      },
      profileQA: {
        dataQuality: {
          rating: '',
          comment: ''
        },
        storyQuoteQuality: {
          rating: '',
          comment: ''
        },
        imageQuality: {
          rating: '',
          comment: ''
        },
        waiverQuality: {
          rating: '',
          comment: ''
        },
      },
      disableQASaving: false,
      disableCommentSaving: false,
      commentsArr: [],
      isReadOnly: false,
    }
  },
  components: {
    ratingAndComment,
    commentWithTools
  },
  validations() {
    let vm = this,
        validationObj = {};
    switch (vm.feedbackView) {
      case 'RateAndApprove':
        validationObj = {
          profileApproval: {
            status: {required: helpers.withMessage("Please select the approval status of the profile", required)},
            reason: {requiredIfProfileNotApproved: helpers.withMessage("Please provide the reason for the approval status", requiredIf(vm.profileApproval.status === 'profilereturned' || vm.profileApproval.status === 'profilerejected'))},
            fundingPocket: {requiredIfProfileApproved: helpers.withMessage("Please provide the source of funds for this surgery", requiredIf(vm.profileApproval.status === 'profileapproved'))},
            tagForFuture: {requiredIfProfileApproved: helpers.withMessage("Please select if the profile should be tagged for future reference", requiredIf(vm.profileApproval.status === 'profileapproved'))},
            fundingPocketWatsi: {requiredIfProfileApprovedInWatsi: helpers.withMessage("Please provide the Watsi ID of the case", requiredIf(vm.profileApproval.fundingPocket === 'watsi'))},
            fundingPocketFundManagerApproved: {requiredIfFundingFromInternal: helpers.withMessage("Please provide the fund manager response", requiredIf(vm.profileApproval.fundingPocket === 'contingencyfund'))}
          },
          profileQA: {
            dataQuality: {
              rating: {requiredIfProfileApproved: helpers.withMessage("Please provide the rating for the data quality", requiredIf(vm.profileApproval.status === 'profileapproved'))},
              comment: {requiredIfRatingPoor: helpers.withMessage("Please provide the data quality comment", requiredIf(vm.profileApproval.status === 'profileapproved' && vm.profileQA.dataQuality.rating <= 2))}
            },
            storyQuoteQuality: {
              rating: {requiredIfProfileApproved: helpers.withMessage("Please provide the rating for the story and quote quality", requiredIf(vm.profileApproval.status === 'profileapproved'))},
              comment: {required: helpers.withMessage("Please provide the story and quote quality comment", requiredIf(vm.profileApproval.status === 'profileapproved' && vm.profileQA.storyQuoteQuality.rating <= 2))}
            },
            imageQuality: {
              rating: {requiredIfProfileApproved: helpers.withMessage("Please provide the rating for the images quality", requiredIf(vm.profileApproval.status === 'profileapproved'))},
              comment: {required: helpers.withMessage("Please provide the images quality comment", requiredIf(vm.profileApproval.status === 'profileapproved' && vm.profileQA.imageQuality.rating <= 2))}
            },
            waiverQuality: {
              rating: {requiredIfProfileApproved: helpers.withMessage("Please provide the rating for the waiver quality", requiredIf(vm.profileApproval.status === 'profileapproved'))},
              comment: {required: helpers.withMessage("Please provide the waiver quality comment", requiredIf(vm.profileApproval.status === 'profileapproved' && vm.profileQA.waiverQuality.rating <= 2))}
            }
          }
        }
        break;
      case 'commentOnly':
        validationObj = {
          profileComment: {required: helpers.withMessage("Please provide the comment text", required)}
        }
        break;
    }
    return validationObj;
  },
  methods: {
    closeProfileForm: function () {
      let vm = this;
      vm.$emit('profileSaved');
    },
    async validateForm() {
      await this.v$.$validate();
    },
    resize(textAreaRef) {
      let vm = this;
      let element = vm.$refs[textAreaRef];
      element.style.height = "18px";
      element.style.height = element.scrollHeight + "px";
    },
    setFeedbackView: function (feedbackViewToShow) {
      let vm = this;
      vm.feedbackViewBtn = feedbackViewToShow;
    },
    imageRatingStar: function (emittedRating) {
      let vm = this;
      vm.profileQA.imageQuality.rating = emittedRating
    },
    imageRatingComment: function (emittedComment) {
      let vm = this;
      vm.profileQA.imageQuality.comment = emittedComment
    },
    waiverRatingStar: function (emittedRating) {
      let vm = this;
      vm.profileQA.waiverQuality.rating = emittedRating
    },
    waiverRatingComment: function (emittedComment) {
      let vm = this;
      vm.profileQA.waiverQuality.comment = emittedComment
    },
    dataRatingStar: function (emittedRating) {
      let vm = this;
      vm.profileQA.dataQuality.rating = emittedRating
    },
    dataRatingComment: function (emittedComment) {
      let vm = this;
      vm.profileQA.dataQuality.comment = emittedComment
    },
    storyQuoteRatingStar: function (emittedRating) {
      let vm = this;
      vm.profileQA.storyQuoteQuality.rating = emittedRating
    },
    storyQuoteRatingComment: function (emittedComment) {
      let vm = this;
      vm.profileQA.storyQuoteQuality.comment = emittedComment
    },
    showFundsLimits: function () {
      let vm = this;

      vm.$axios
          .post('/profile/action/fetchFundingStatuses', {
            profilePartner: vm.profilePartner
          }, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${vm.loginData.token}`
            }
          })
          .then(function (response) {
            console.log(response.data);


            let options = {
              xaxis: {
                categories: response.data.categories,
                labels: {
                  formatter: (val) => {
                    return val / 1000 + 'K'
                  }
                }
              },
              series: [
                response.data.limit,
                response.data.approved,
                response.data.awaiting
              ],
              chart: {
                type: 'bar',
                height: 300,
                stacked: true,
              },
              stroke: {
                width: 1,
                colors: ['#fff']
              },
              dataLabels: {
                formatter: (val) => {
                  return val / 1000 + 'K'
                }
              },
              plotOptions: {
                bar: {
                  horizontal: true
                }
              },
              fill: {
                opacity: 1,
              },
              // colors: ['#008FFB', '#636B2F', '#CCFF00'],
              colors: ['#008FFBFF', '#00E396FF', '#80F1CBFF'],
              legend: {
                position: 'top',
                horizontalAlign: 'left'
              }
            };

            let fundPositionChartSpace = document.querySelector("#fundPositionChart");
            if (fundPositionChartSpace) {
              let chart = new vm.$ApexCharts(fundPositionChartSpace, options);
              chart.render();
            }

            vm.showLoadingAnimation = false;

          });


    },
    processApproval: function () {
      let vm = this;
      vm.validateForm();

      if (vm.v$.$errors.length === 0) {

        vm.disableQASaving = true;

        vm.$axios
            .post('/profile/action/approveProfile', {
              profileApproval: vm.profileApproval,
              profileQA: vm.profileQA,
              activeProfile: vm.activeProfile,
              profilePartner: vm.profilePartner,
              profileId: vm.activeProfile.profileIdentifier,
              coordData: vm.currentData
            }, {
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${vm.loginData.token}`
              }
            })
            .then(function (response) {
              switch (response.data.success) {
                case 'true':
                  vm.profileSubmittedMsg = response.data.msg;
                  vm.profileSubmitted = true;
                  break;
                case 'false':
                  vm.disableQASaving = false;
                  vm.profileSubmitted = false;
                  break;
              }
            });
      }
    },
    processCommenting: function () {
      let vm = this;

      vm.validateForm();

      if (vm.v$.$errors.length === 0) {

        vm.disableCommentSaving = true;
        vm.$axios
            .post('/profile/action/commentOnProfile', {
              profileComment: vm.profileComment,
              profilePartner: vm.profilePartner,
              profileId: vm.activeProfile.profileIdentifier,
              coordData: vm.currentData
            }, {
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${vm.loginData.token}`
              }
            });
      }
    },
    fetchComments: function () {
      let vm = this;
      try {
        vm.$axios
            .post('/profile/action/fetchComments', {
              profileTS: vm.profileTS
            }, {
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${vm.currentData.token}`
              }
            })
            .then(function (response) {
              switch (response.data.success) {
                case 'true':
                  vm.commentsArr = response.data.comments;
                  break;
              }
            });
      } catch (error) {
        console.error(error);
      }
    },

    previewURL(imageSource, initialViewIndex) {

      let vm = this;

      viewerApi({
        options: {
          "inline": false,
          "button": true,
          "navbar": true,
          "title": true,
          "toolbar": true,
          "tooltip": true,
          "movable": true,
          "zoomable": true,
          "rotatable": true,
          "scalable": true,
          "transition": true,
          "fullscreen": true,
          "keyboard": true,
          "url": "data-source",
          initialViewIndex: initialViewIndex
        },
        images: vm.sourceImageURLs[imageSource]
      })
    },
  },
  computed: {
    isWatsiCase() {
      let vm = this;
      return vm.showFundPositionChart && vm.profileApproval.fundingPocket === 'watsi';
    },
    isFundManagerCase() {
      let vm = this;
      return vm.showFundPositionChart && vm.profileApproval.fundingPocket === 'contingencyfund';
    },
    isOtherCase() {
      let vm = this;
      return vm.showFundPositionChart && vm.profileApproval.fundingPocket === 'amhother';
    },
    feedbackView() {
      let vm = this,
          returnValue = 'commentOnly';
      if (vm.dataFrom === 'rejectedProfile') {
        returnValue = 'commentOnly'
      } else {
        if (vm.feedbackViewBtn === '') {
          switch (vm.currentData.role) {
            case 'Representative':
              returnValue = 'commentOnly'
              break;
            case 'Coordinator':
              returnValue = 'RateAndApprove'
              break;
          }
        } else {
          returnValue = vm.feedbackViewBtn;
        }
      }

      return returnValue;
    },
    sourceImageURLs() {
      let vm = this;
      let imageURLs = {preop: [], condition: [], ids: [], attachments: []};
      vm.$_.forEach(vm.activeProfile.faceImages, function (faceImage) {
        imageURLs.preop.push({
          'src': faceImage.view,
          'data-source': faceImage.view,
        });
      });
      vm.$_.forEach(vm.activeProfile.conditionImages, function (conditionImage) {
        imageURLs.condition.push({
          'src': conditionImage.view,
          'data-source': conditionImage.view,
        });
      });
      vm.$_.forEach(vm.activeProfile.identificationImages, function (identificationImage) {
        imageURLs.ids.push({
          'src': identificationImage.view,
          'data-source': identificationImage.view,
        });
      });
      imageURLs.attachments.push({
        'src': vm.activeProfile.waiverImages[0].view,
        'data-source': vm.activeProfile.waiverImages[0].view,
      });
      vm.$_.forEach(vm.activeProfile.additionalAttachments, function (additionalAttachment) {
        imageURLs.attachments.push({
          'src': additionalAttachment.view,
          'data-source': additionalAttachment.view,
        });
      });
      vm.$_.forEach(vm.commentsArr, function (comment, commentIndex) {
        imageURLs[`comment_${commentIndex}`] = [];
        vm.$_.forEach(comment.attachments, function (commentattachment) {
          imageURLs[`comment_${commentIndex}`].push({
            'src': commentattachment.view,
            'data-source': commentattachment.view,
          });
        });
      });


      return imageURLs;
    }
  },
  watch: {
    profileApproval: {
      handler(newValue,) {
        let vm = this;
        // if (!vm.showFundPositionChart) {
        if (newValue.status === 'profileapproved') {
          vm.showFundPositionChart = true;
          vm.showLoadingAnimation = true;
          vm.approvalRemarksPlaceHolder = 'Any additional remarks';
          setTimeout(function () {
            vm.showFundsLimits();
          }, 3000)
        }

        if (newValue.status === 'profilereturned' || newValue.status === 'profilerejected') {
          vm.showFundPositionChart = false;
          vm.profileApproval.fundingPocket = '';
          vm.profileApproval.fundingPocketWatsi = '';
          vm.profileApproval.fundingPocketFundManagerApproved = '';
        }
        if (newValue.status === 'profilereturned') {
          vm.approvalRemarksPlaceHolder = 'Reason for sending back the profile';
        }
        if (newValue.status === 'profilerejected') {
          vm.approvalRemarksPlaceHolder = 'Reason for rejecting the profile';
        }

        // }


        // if (vm.showFundPositionChart) {
        //
        // }

      },
      deep: true
    }
  },
  async mounted() {
    let vm = this;
    const storedAccount = localStorage.getItem("account");
    vm.currentData = JSON.parse(storedAccount);

    vm.IDB = await vm.getIDB();

    let
        unapprovedProfilePatient,
        approvedProfilePatient,
        rejectedProfilePatient;
    switch (vm.dataFrom) {
      case 'submittedProfile':


        unapprovedProfilePatient = await vm.getPatientFromDb(vm.IDB, 'unapprovedProfiles', vm.profileID, 'caseId', false);


        if (typeof unapprovedProfilePatient[0] !== 'undefined') {
          vm.profileTS = vm.$_.split(vm.profileID, '-')[1];
          vm.activeProfile = unapprovedProfilePatient[0].caseData;
          vm.profilePartner = unapprovedProfilePatient[0].caseData.partnerid;
          vm.profileLoading = false;
          vm.fetchComments()
        } else {
          vm.profileLoadingText = 'Profile data was not found';
        }


        vm.isReadOnly = false;
        break;
      case 'approvedProfile':

        approvedProfilePatient = await vm.getPatientFromDb(vm.IDB, 'approvedProfiles', vm.profileID, 'caseId', false);

        if (typeof approvedProfilePatient[0] !== 'undefined') {
          vm.profileTS = vm.$_.split(vm.profileID, '-')[1];
          vm.activeProfile = approvedProfilePatient[0].caseData;
          vm.profilePartner = approvedProfilePatient[0].caseData.partnerid;
          vm.profileLoading = false;
          vm.fetchComments()
        } else {
          vm.profileLoadingText = 'Profile data was not found';
        }


        vm.isReadOnly = false;
        break;
      case 'rejectedProfile':


        rejectedProfilePatient = await vm.getPatientFromDb(vm.IDB, 'rejectedProfiles', vm.profileID, 'caseId', false);

        if (typeof rejectedProfilePatient[0] !== 'undefined') {
          vm.profileTS = vm.$_.split(vm.profileID, '-')[1];
          vm.activeProfile = rejectedProfilePatient[0].caseData;
          vm.profilePartner = rejectedProfilePatient[0].caseData.partnerid;
          vm.profileLoading = false;
          vm.fetchComments()
        } else {
          vm.profileLoadingText = 'Profile data was not found';
        }


        vm.isReadOnly = true;
        break;
    }


  },
};
</script>

<template>
  <div class="profile-form-container" v-if="!profileSubmitted && !profileLoading">
    <div class="container">
      <div class="columns is-multiline is-mobile is-vcentered">

        <div class="column is-full"></div>
        <div class="column is-full">
          <div id="personalOne" class="columns is-multiline is-mobile is-vcentered section-box">
            <div class="column is-full section-box-title-column">
              <div class="section-box-title-text">Case Data</div>
            </div>

            <div class="column is-half has-text-left label-no-padding-bottom label-no-padding-top full-width-cell-last">
              <label class="label has-text-centered">Case ID:</label>
            </div>
            <div class="column is-half has-text-left label-no-padding-bottom label-no-padding-top full-width-cell-last">
              <label class="label has-text-left">{{ activeProfile.profileIdentifier }}</label>
            </div>

            <div class="column is-half has-text-left label-no-padding-bottom label-no-padding-top full-width-cell-last">
              <label class="label has-text-centered">Partner:</label>
            </div>
            <div class="column is-half has-text-left label-no-padding-bottom label-no-padding-top full-width-cell-last">
              <label class="label has-text-left">{{ activeProfile.partnerIdentity }}</label>
            </div>

          </div>
        </div>

        <div class="column is-full">
          <h1 class="is-size-3 is-underlined">Patient Information</h1>
        </div>

        <div class="column is-full">
          <div id="personalOne" class="columns is-multiline is-mobile is-vcentered section-box">
            <div class="column is-full section-box-title-column">
              <div class="section-box-title-text">Personal</div>
            </div>
            <div class="column is-full can-scroll-content">
              <table class="table is-striped is-fullwidth">
                <tbody>
                <tr>
                  <td class="left-side-table-cell">
                    <label class="label has-text-left">Full Name</label>
                    <div class="has-text-centered">{{ activeProfile.patientName }}</div>
                  </td>
                  <td class="right-side-table-cell">
                    <label class="label has-text-left">Patient Hospital Number</label>
                    <div class="has-text-centered">{{ activeProfile.inpatientNumber }}</div>
                  </td>
                </tr>
                <tr>
                  <td class="left-side-table-cell">
                    <label class="label has-text-left">Gender</label>
                    <div class="has-text-centered">{{ activeProfile.patientGender }}</div>
                  </td>
                  <td class="right-side-table-cell">
                    <label class="label has-text-left">Date of Birth</label>
                    <div class="has-text-centered">{{ activeProfile.patientDob }}</div>
                  </td>
                </tr>
                <tr>
                  <td class="left-side-table-cell">
                    <label class="label has-text-left">Marital Status</label>
                    <div class="has-text-centered">{{ activeProfile.patientMarital }}</div>
                  </td>
                  <td class="right-side-table-cell">
                    <label class="label has-text-left">Education Level</label>
                    <div class="has-text-centered">{{ activeProfile.patientEducation }}</div>
                  </td>
                </tr>
                <tr>
                  <td class="left-side-table-cell">
                    <label class="label has-text-left">Patient Descriptor</label>
                    <div class="has-text-centered">{{ activeProfile.patientDescription }}</div>
                  </td>
                  <td class="right-side-table-cell">
                    <label class="label has-text-left">Has Health Insurance</label>
                    <div class="has-text-centered">{{ activeProfile.hasInsurance }}</div>
                  </td>
                </tr>
                <tr>
                  <td class="left-side-table-cell">
                    <label class="label has-text-left">Phone Number of the Patient</label>
                    <div class="has-text-centered">{{ activeProfile.patientPhoneNumber }}</div>
                  </td>
                  <td class="right-side-table-cell">
                    <label class="label has-text-left">Government Identification</label>
                    <div class="has-text-centered">{{ activeProfile.identificationDocument }}</div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="column is-full" v-if="activeProfile.patientAgeGroup ==='Minor'"></div>
        <div class="column is-full" v-if="activeProfile.patientAgeGroup ==='Minor'">
          <div id="personalTwo" class="columns is-multiline is-mobile is-vcentered section-box">
            <div class="column is-full section-box-title-column">
              <div class="section-box-title-text" v-if="activeProfile.guardianIsNok==='No'">Guardian</div>
              <div class="section-box-title-text" v-if="activeProfile.guardianIsNok==='Yes'">Guardian and Next of Kin
              </div>
            </div>
            <div class="column is-full can-scroll-content">
              <table class="table is-striped is-fullwidth">
                <tbody>
                <tr>
                  <td colspan="2">
                    <label class="label has-text-left">Guardian Name</label>
                    <div class="has-text-centered">{{ activeProfile.guardianName }}</div>
                  </td>
                </tr>
                <tr>
                  <td class="left-side-table-cell">
                    <label class="label has-text-left">Guardian Phone Number</label>
                    <div class="has-text-centered">{{ activeProfile.guardianPhone }}</div>
                  </td>
                  <td class="right-side-table-cell">
                    <label class="label has-text-left">Relationship</label>
                    <div class="has-text-centered">{{ activeProfile.guardianRelation }}</div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="column is-full"
             v-if="activeProfile.guardianIsNok==='No' || activeProfile.patientAgeGroup ==='Adult'"></div>
        <div class="column is-full"
             v-if="activeProfile.guardianIsNok==='No' || activeProfile.patientAgeGroup ==='Adult'">
          <div id="personalThree" class="columns is-multiline is-mobile is-vcentered section-box">
            <div class="column is-full section-box-title-column">
              <div class="section-box-title-text">Next of Kin</div>
            </div>
            <div class="column is-full can-scroll-content">
              <table class="table is-striped is-fullwidth">
                <tbody>
                <tr>
                  <td colspan="2">
                    <label class="label has-text-left">Name</label>
                    <div class="has-text-centered">{{ activeProfile.nextOfKinName }}</div>
                  </td>
                </tr>
                <tr>
                  <td class="left-side-table-cell">
                    <label class="label has-text-left">Phone Number</label>
                    <div class="has-text-centered">{{ activeProfile.nextOfKinPhone }}</div>
                  </td>
                  <td class="right-side-table-cell">
                    <label class="label has-text-left">Relationship</label>
                    <div class="has-text-centered">{{ activeProfile.nextOfKinRelation }}</div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="column is-full"></div>
        <div class="column is-full">
          <div id="personalFour" class="columns is-multiline is-mobile is-vcentered section-box">
            <div class="column is-full section-box-title-column">
              <div class="section-box-title-text">Origin</div>
            </div>
            <div class="column is-full can-scroll-content">
              <table class="table is-striped is-fullwidth">
                <tbody>
                <tr>
                  <td colspan="2">
                    <label class="label has-text-left">Location and District of Origin</label>
                    <div class="has-text-centered">{{ activeProfile.patientOrigin }}</div>
                  </td>
                </tr>
                <tr>
                  <td class="left-side-table-cell">
                    <label class="label has-text-left">Nearest Health Center</label>
                    <div class="has-text-centered">{{ activeProfile.closestHealthCenter }}</div>
                  </td>
                  <td class="right-side-table-cell">
                    <label class="label has-text-left">Referral From</label>
                    <div class="has-text-centered">{{ activeProfile.referralFrom }}</div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="column is-full"></div>
        <div class="column is-full">
          <div id="personalFive" class="columns is-multiline is-mobile is-vcentered section-box">
            <div class="column is-full section-box-title-column">
              <div class="section-box-title-text">Privacy</div>
            </div>
            <div class="column is-full can-scroll-content">
              <table class="table is-striped is-fullwidth">
                <tbody>
                <tr>
                  <td colspan="2">
                    <label class="label has-text-left">Has requested for privacy</label>
                    <div class="has-text-centered" v-html="activeProfile.patientPrivacy"></div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="column is-full">
          <h1 class="is-size-3 is-underlined">Social Economic</h1>
        </div>

        <div class="column is-full">
          <div id="personalSix" class="columns is-multiline is-mobile is-vcentered section-box">
            <div class="column is-full section-box-title-column">
              <div class="section-box-title-text">Employment</div>
            </div>
            <div class="column is-full can-scroll-content">
              <table class="table is-striped is-fullwidth">
                <tbody>
                <tr>
                  <td class="left-side-table-cell">
                    <label class="label has-text-left">Employment details of the {{
                        activeProfile.patientOrGuardian
                      }}</label>
                    <div class="has-text-centered">
                      <strong>Profile: </strong>{{ activeProfile.employmentProfile }}
                      <span v-if="activeProfile.employmentType!=='-'"><br><strong>Type: </strong>{{
                          activeProfile.employmentType
                        }}</span>
                      <br><strong>Description: </strong>
                      <span v-if="activeProfile.employmentDescription!=='-'">
                      {{ activeProfile.employmentDescription }}
                    </span>
                      <span v-if="activeProfile.selfemploymentDescription!=='-'">
                      {{ activeProfile.selfemploymentDescription }}
                    </span>
                    </div>
                  </td>
                  <td class="right-side-table-cell">
                    <label class="label has-text-left">Monthly income of the {{ activeProfile.patientOrGuardian }}
                      (USD)</label>
                    <div class="has-text-centered">{{ activeProfile.monthlyIncome }}</div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="column is-full"></div>
        <div class="column is-full">
          <div id="personalSeven" class="columns is-multiline is-mobile is-vcentered section-box">
            <div class="column is-full section-box-title-column">
              <div class="section-box-title-text">Housing</div>
            </div>
            <div class="column is-full can-scroll-content">
              <table class="table is-striped is-fullwidth">
                <tbody>
                <tr>
                  <td class="left-side-table-cell">
                    <label class="label has-text-left">Type of Housing</label>
                    <div class="has-text-centered">{{ activeProfile.housingType }}</div>
                  </td>
                  <td class="right-side-table-cell">
                    <label class="label has-text-left">Number of rooms</label>
                    <div class="has-text-centered">{{ activeProfile.houseRooms }}</div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="column is-full"></div>
        <div class="column is-full">
          <div id="personalEight" class="columns is-multiline is-mobile is-vcentered section-box">
            <div class="column is-full section-box-title-column">
              <div class="section-box-title-text">Energy</div>
            </div>
            <div class="column is-full can-scroll-content">
              <table class="table is-striped is-fullwidth">
                <tbody>
                <tr>
                  <td class="left-side-table-cell">
                    <label class="label has-text-left">The main source of power (Lighting)</label>
                    <div class="has-text-centered">{{ activeProfile.lightingEnergy }}</div>
                  </td>
                  <td class="right-side-table-cell">
                    <label class="label has-text-left">The main source of energy (cooking)</label>
                    <div class="has-text-centered">{{ activeProfile.cookingEnergy }}</div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="column is-full">
          <h1 class="is-size-3 is-underlined">Family</h1>
        </div>

        <div class="column is-full">
          <div id="personalNine" class="columns is-multiline is-mobile is-vcentered section-box">
            <div class="column is-full section-box-title-column">
              <div class="section-box-title-text">Household</div>
            </div>
            <div class="column is-full can-scroll-content">
              <table class="table is-striped is-fullwidth">
                <tbody>
                <tr>
                  <td class="left-side-table-cell">
                    <label class="label has-text-left">Number of household members the {{
                        activeProfile.patientOrGuardian
                      }}
                      supports</label>
                    <div class="has-text-centered">{{ activeProfile.supportingHouseHoldOf }}</div>
                  </td>
                  <td class="right-side-table-cell">
                    <label class="label has-text-left">Number of Children the {{ activeProfile.patientOrGuardian }}
                      has</label>
                    <div class="has-text-centered">{{ activeProfile.numberOfChildren }}</div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="column is-full"></div>
      </div>
    </div>
    <div class="container">
      <div class="columns is-multiline is-mobile is-vcentered">
        <div class="column is-full">
          <h1 class="is-size-3 is-underlined">Illness Profile</h1>
        </div>
        <div class="column is-full">
          <div id="illnessOne" class="columns is-multiline is-mobile is-vcentered section-box">
            <div class="column is-full section-box-title-column">
              <div class="section-box-title-text">Surgery</div>
            </div>
            <div class="column is-full can-scroll-content">
              <table class="table is-striped is-fullwidth">
                <tbody>
                <tr>
                  <td class="left-side-table-cell" colspan="3">
                    <label class="label has-text-left">Condition</label>
                    <div class="has-text-centered">{{ activeProfile.patientCondition }}</div>
                  </td>
                  <td class="right-side-table-cell" colspan="3">
                    <label class="label has-text-left">Length of stay with condition</label>
                    <div class="has-text-centered">{{ activeProfile.timeWithCondition }}</div>
                  </td>
                </tr>
                <tr>
                  <td class="left-side-table-cell" colspan="2">
                    <label class="label has-text-left">Type</label>
                    <div class="has-text-centered">{{ activeProfile.surgeryType }}</div>
                  </td>
                  <td class="middle-table-cell" colspan="2">
                    <label class="label has-text-left">Surgery required</label>
                    <div class="has-text-centered">{{ activeProfile.surgeryRequired }}</div>
                  </td>
                  <td class="right-side-table-cell" colspan="2">
                    <label class="label has-text-left">Estimated Date of Surgery</label>
                    <div class="has-text-centered">{{ activeProfile.estimatedSurgeryDay }}</div>
                  </td>
                </tr>
                <tr>
                  <td class="left-side-table-cell" colspan="3">
                    <label class="label has-text-left">Gravidity</label>
                    <div class="has-text-centered">{{ activeProfile.gravidity }}</div>
                  </td>
                  <td class="right-side-table-cell" colspan="3">
                    <label class="label has-text-left">Parity</label>
                    <div class="has-text-centered">{{ activeProfile.parity }}</div>
                  </td>
                </tr>
                <tr>
                  <td class="left-side-table-cell" colspan="3">
                    <label class="label has-text-left">Safe Ask</label>
                    <div class="has-text-centered safe-ask-amount">{{ activeProfile.safeAskAmount }}</div>
                  </td>
                  <td class="right-side-table-cell" colspan="3">
                    <label class="label has-text-left">Co-Payment Amount</label>
                    <div class="has-text-centered" v-html="activeProfile.coPaymentDisplay"></div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="column is-full"></div>
        <div class="column is-full">
          <div id="illnessTwo" class="columns is-multiline is-mobile is-vcentered section-box">
            <div class="column is-full section-box-title-column">
              <div class="section-box-title-text">Transport</div>
            </div>
            <div class="column is-full can-scroll-content">
              <table class="table is-striped is-fullwidth">
                <tbody>
                <tr>
                  <td class="left-side-table-cell">
                    <label class="label has-text-left">Time taken to reach the hospital</label>
                    <div class="has-text-centered">{{ activeProfile.timeTakenToHospital }}</div>
                  </td>
                  <td class="middle-table-cell">
                    <label class="label has-text-left">Main mode of transport to the hospital</label>
                    <div class="has-text-centered">{{ activeProfile.modeOfTransport }}</div>
                  </td>
                  <td class="right-side-table-cell">
                    <label class="label has-text-left">Amount spent on transport round trip</label>
                    <div class="has-text-centered">{{ activeProfile.costOfTransport }}</div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="column is-full"></div>
        <div class="column is-full">
          <div id="illnessThree" class="columns is-multiline is-mobile is-vcentered section-box">
            <div class="column is-full section-box-title-column">
              <div class="section-box-title-text">Patient Story</div>
            </div>
            <div class="column is-full can-scroll-content">
              <table class="table is-striped is-fullwidth">
                <tbody>
                <tr>
                  <td>
                    <div class="has-text-justified">{{ activeProfile.patientStory }}</div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="column is-full"></div>
        <div class="column is-full">
          <div id="illnessFour" class="columns is-multiline is-mobile is-vcentered section-box">
            <div class="column is-full section-box-title-column">
              <div class="section-box-title-text">Personal Quote</div>
            </div>
            <div class="column is-full can-scroll-content">
              <table class="table is-striped is-fullwidth">
                <tbody>
                <tr>
                  <td>
                    <div class="has-text-justified">{{ activeProfile.patientQuote }}</div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="column is-full"></div>
      </div>
    </div>
    <div class="container">
      <div class="columns is-multiline is-mobile">

        <div class="column is-full">
          <h1 class="is-size-3 is-underlined">Patient Photo(s)</h1>
        </div>

        <div class="column is-full" v-if="activeProfile.faceImages.length">
          <div id="AttachmentsTwo" class="columns is-multiline is-vcentered section-box">
            <div class="column is-full section-box-title-column">
              <div class="section-box-title-text">Pre-OP Photos</div>
            </div>
            <div class="column is-half input-no-padding-top" v-for="(faceImage, index) in activeProfile.faceImages"
                 v-bind:key="index">
              <div class="image-relative-container" v-on:click="previewURL('preop',index)">
                <div class="image-flex-container zoom-image">
                  <img v-bind:src="`${faceImage.thumbnail}`" alt="Patient Face" class="image">
                </div>
              </div>
              <div class="is-centered">Timestamp: <span>{{ faceImage.timestamp }}</span></div>
              <div class="buttons has-addons is-centered">
                <a class="button" v-if="faceImage.location" v-bind:href="faceImage.location"
                   target="_blank">Location</a>
                <a v-bind:href="`${faceImage.download}?form=profile&fullname=${activeProfile.patientName}`"
                   target="_blank" class="button">Download</a>
              </div>
            </div>
          </div>
        </div>

        <div class="column is-full" v-if="activeProfile.conditionImages.length"></div>
        <div class="column is-full" v-if="activeProfile.conditionImages.length">
          <div id="AttachmentsThree" class="columns is-multiline is-vcentered section-box">
            <div class="column is-full section-box-title-column">
              <div class="section-box-title-text">Condition</div>
            </div>
            <div class="column is-half input-no-padding-top"
                 v-for="(conditionImage, index) in activeProfile.conditionImages"
                 v-bind:key="index">
              <div class="image-relative-container" v-on:click="previewURL('condition',index)">
                <div class="image-flex-container zoom-image">
                  <img v-bind:src="`${conditionImage.thumbnail}`" alt="Patient Condition"
                       class="image">
                </div>
                <div class="image-flex-container">Timestamp: <span>{{ conditionImage.timestamp }}</span>
                </div>
                <div>Location:
                  <a v-bind:href="conditionImage.location" target="_blank"
                     v-if="conditionImage.location!==''">Here</a>
                  <span v-else></span>
                </div>
                <a v-bind:href="`${conditionImage.download}?form=profile&fullname=${activeProfile.patientName}`"
                   target="_blank"
                   class="button is-fullwidth">Download</a>
              </div>
            </div>
          </div>
        </div>

        <div class="column is-full" v-if="activeProfile.identificationDocument!=='-'"></div>
        <div class="column is-full" v-if="activeProfile.identificationDocument!=='-'">
          <div id="AttachmentsFour" class="columns is-multiline is-vcentered section-box">
            <div class="column is-full section-box-title-column">
              <div class="section-box-title-text">Identification Documents</div>
            </div>
            <div class="column is-half input-no-padding-top"
                 v-for="(identificationImage, index) in activeProfile.identificationImages"
                 v-bind:key="index">
              <div class="image-relative-container" v-on:click="previewURL('ids',index)">
                <div class="image-flex-container zoom-image">
                  <img v-bind:src="`${identificationImage.thumbnail}`"
                       alt="Identification Document"
                       class="image">
                </div>
                <div class="image-flex-container">Timestamp: <span>{{ identificationImage.timestamp }}</span>
                </div>
                <div>Location:
                  <a v-bind:href="identificationImage.location" target="_blank"
                     v-if="identificationImage.location!==''">Here</a>
                  <span v-else></span>
                </div>
                <a v-bind:href="`${identificationImage.download}?form=profile&fullname=${activeProfile.patientName}`"
                   target="_blank"
                   class="button is-fullwidth">Download</a>
              </div>
            </div>
          </div>
        </div>


        <div class="column is-full"></div>
        <div class="column is-full">
          <div id="additionalAttachments" class="columns is-multiline is-vcentered section-box">
            <div class="column is-full section-box-title-column">
              <div class="section-box-title-text">Additional Attachments</div>
            </div>
            <div class="column is-one-quarter">
              <div class="image-relative-container" v-on:click="previewURL('attachments',0)">
                <div class="image-flex-container zoom-image">
                  <img v-bind:src="`${activeProfile.waiverImages[0].thumbnail}`" alt="Waiver"
                       class="image">
                </div>
                <a v-bind:href="`${activeProfile.waiverImages[0].download}?form=profile&fullname=${activeProfile.patientName}`"
                   target="_blank"
                   class="button is-fullwidth">Download</a>
              </div>
            </div>
            <div class="column is-one-quarter"
                 v-for="(additionalAttachment, index) in activeProfile.additionalAttachments"
                 v-bind:key="index">
              <div class="image-relative-container" v-on:click="previewURL('attachments',index+1)">
                <div class="image-flex-container zoom-image">
                  <img v-bind:src="`${additionalAttachment.thumbnail}`"
                       alt="Additional Attachment"
                       class="image">
                </div>
                <a v-bind:href="`${additionalAttachment.download}?form=profile&fullname=${activeProfile.patientName}`"
                   target="_blank"
                   class="button is-fullwidth">Download</a>
              </div>
            </div>
          </div>
        </div>

        <div class="column is-full"></div>
        <div class="column is-full">
          <div id="AttachmentsSeven" class="columns is-multiline is-mobile is-vcentered section-box">
            <div class="column is-full section-box-title-column">
              <div class="section-box-title-text">Checklist and Confirmation</div>
            </div>
            <div class="column is-full can-scroll-content">
              <table class="table is-striped is-fullwidth">
                <tbody>
                <tr>
                  <td>
                    <label class="label has-text-left">Is the proposed treatment expected to save the patient’s life
                      or significantly increase their standard of living?</label>
                    <div class="has-text-centered">{{ activeProfile.treatmentChangeLife }}</div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <label class="label has-text-left">Do you agree to provide SAFE a complete treatment update within
                      30 days after the proposed treatment date listed in this form?</label>
                    <div class="has-text-centered">{{ activeProfile.treatmentUpdate }}</div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="column is-full"></div>

      </div>
    </div>
    <div class="container">
      <div class="columns is-multiline is-mobile">

        <div class="column is-full" v-if="!isReadOnly">
          <h1 class="is-size-3 is-underlined" v-if="currentData.role==='Coordinator' && profileApproving">Approval and
            Comments</h1>
          <h1 class="is-size-3 is-underlined" v-if="currentData.role==='Coordinator' && !profileApproving">Comments</h1>
          <h1 class="is-size-3 is-underlined" v-if="currentData.role==='Representative'">Comments</h1>
        </div>

        <div class="column is-full tabs is-boxed" v-if="currentData.role==='Coordinator' && !isReadOnly">
          <ul>
            <li v-bind:class="{'is-active':feedbackView==='RateAndApprove'}"
                v-on:click="setFeedbackView('RateAndApprove')"
                v-if="profileApproving">
              <a>Rating and Approval</a>
            </li>
            <li v-bind:class="{'is-active':feedbackView==='commentOnly'}"
                v-on:click="setFeedbackView('commentOnly')"
            >
              <a>Comment Only</a>
            </li>
          </ul>
        </div>
        <div class="column is-full" v-if="!isReadOnly"></div>


        <div class="column is-full" v-if="feedbackView==='commentOnly'">
          <div id="CoordFeedbackOne" class="columns is-multiline is-mobile is-vcentered section-box">
            <div class="column is-full section-box-title-column">
              <div class="section-box-title-text">Comments</div>
            </div>
            <div class="column is-full can-scroll-content">
              <table class="table is-striped is-fullwidth">
                <tbody>
                <tr v-if="commentsArr.length===0 && isReadOnly">
                  <td>There are no comments</td>
                </tr>
                <tr v-for="(comment, commentIndex) in commentsArr"
                    v-bind:key="commentIndex">
                  <td>
                    <div class="columns is-multiline">
                      <div class="column is-full has-text-justified">{{ comment.commentText }}</div>
                      <div class="column is-one-quarter" v-for="(attachment, attachmentIndex) in comment.attachments"
                           v-bind:key="attachmentIndex">

                        <div class="image-relative-container"
                             v-on:click="previewURL(`comment_${commentIndex}`,attachmentIndex)">
                          <div class="image-flex-container zoom-image">
                            <img v-bind:src="`${attachment.thumbnail}`" alt="Comment Attachment" class="image">
                          </div>
                        </div>
                        <a v-bind:href="`${attachment.download}?form=comment&fullname=${activeProfile.patientName}`"
                           target="_blank"
                           class="button is-fullwidth">Download</a>

                      </div>
                      <div class="column is-full has-text-right">{{ comment.postdBy.name }} at {{
                          comment.commentDate
                        }}
                      </div>
                    </div>
                  </td>
                </tr>
                <tr v-if="!isReadOnly">
                  <td>
                    <commentWithTools
                        v-bind:profileTS="profileTS"
                        v-bind:profilePartner="profilePartner"
                        v-bind:textAreaPlaceholder="''"
                        v-bind:textAreaGuideline="''"
                        v-bind:commentError="false"
                        v-on:commentPosted="fetchComments"
                    >
                    </commentWithTools>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="column is-full" v-if="feedbackView==='RateAndApprove' && !isReadOnly && profileApproving">
          <div id="CoordFeedbackTwo" class="columns is-multiline is-mobile is-vcentered section-box">
            <div class="column is-full section-box-title-column">
              <div class="section-box-title-text">Coordinator Action</div>
            </div>

            <div class="column is-one-quarter">
              Approval Status:
            </div>
            <div class="column is-three-quarters">
              <div class="fancy-input-group columns is-multiline is-mobile is-vcentered"
                   v-bind:class="{'error-input':v$.profileApproval.status.$errors.length>0}">
                <input type="radio" name="approvalstatus" id="profileapproved" value="profileapproved"
                       class="fancy-input"
                       v-model="profileApproval.status"/>
                <label for="profileapproved"
                       class="fancy-input-label column no-wrapping-label">Approved</label>
                <input type="radio" name="approvalstatus" id="profilereturned" value="profilereturned"
                       class="fancy-input" v-model="profileApproval.status"/>
                <label for="profilereturned" class="fancy-input-label column no-wrapping-label">Send Back</label>
                <input type="radio" name="approvalstatus" id="profilerejected" value="profilerejected"
                       class="fancy-input" v-model="profileApproval.status"/>
                <label for="profilerejected" class="fancy-input-label column no-wrapping-label">Rejected</label>
              </div>
            </div>

            <div class="column is-full has-text-centered label-no-padding-bottom"
                 v-if="profileApproval.status === 'profileapproved'">
              <label class="label has-text-centered">Quality of Data</label>
            </div>
            <div class="column is-full input-no-padding-top" v-if="profileApproval.status === 'profileapproved'">
              <div class="field">
                <p class="control is-expanded has-icons-left">
                  <ratingAndComment v-bind:textAreaPlaceholder="'Data rating comment'"
                                    v-bind:textAreaGuideline="''"
                                    v-bind:maxRating="5"
                                    v-bind:ratingError="profileQA.dataQuality.rating===0"
                                    v-bind:commentError="$_.trim(profileQA.dataQuality.comment)==='' && profileQA.dataQuality.rating<=2"
                                    v-bind:ratingValue="profileQA.dataQuality.rating"
                                    v-bind:ratingType="'rating'"
                                    v-on:starRating="dataRatingStar"
                                    v-on:commentRating="dataRatingComment"
                  ></ratingAndComment>
                </p>
              </div>
            </div>

            <div class="column is-full has-text-centered label-no-padding-bottom"
                 v-if="profileApproval.status === 'profileapproved'">
              <label class="label has-text-centered">Quality of Story and Quote</label>
            </div>
            <div class="column is-full input-no-padding-top" v-if="profileApproval.status === 'profileapproved'">
              <div class="field">
                <p class="control is-expanded has-icons-left">
                  <ratingAndComment v-bind:textAreaPlaceholder="'Story and quote rating comment'"
                                    v-bind:textAreaGuideline="''"
                                    v-bind:maxRating="5"
                                    v-bind:ratingError="profileQA.storyQuoteQuality.rating===0"
                                    v-bind:commentError="$_.trim(profileQA.storyQuoteQuality.comment)===''  && profileQA.storyQuoteQuality.rating<=2"
                                    v-bind:ratingValue="profileQA.storyQuoteQuality.rating"
                                    v-bind:ratingType="'rating'"
                                    v-on:starRating="storyQuoteRatingStar"
                                    v-on:commentRating="storyQuoteRatingComment"
                  ></ratingAndComment>
                </p>
              </div>
            </div>

            <div class="column is-full has-text-centered label-no-padding-bottom"
                 v-if="profileApproval.status === 'profileapproved'">
              <label class="label has-text-centered">Quality of Images</label>
            </div>
            <div class="column is-full input-no-padding-top" v-if="profileApproval.status === 'profileapproved'">
              <div class="field">
                <p class="control is-expanded has-icons-left">
                  <ratingAndComment v-bind:textAreaPlaceholder="'Image rating comment'"
                                    v-bind:textAreaGuideline="''"
                                    v-bind:maxRating="5"
                                    v-bind:ratingError="profileQA.imageQuality.rating===0"
                                    v-bind:commentError="$_.trim(profileQA.imageQuality.comment)===''  && profileQA.imageQuality.rating<=2"
                                    v-bind:ratingValue="profileQA.imageQuality.rating"
                                    v-bind:ratingType="'rating'"
                                    v-on:starRating="imageRatingStar"
                                    v-on:commentRating="imageRatingComment"
                  ></ratingAndComment>
                </p>
              </div>
            </div>

            <div class="column is-full has-text-centered label-no-padding-bottom"
                 v-if="profileApproval.status === 'profileapproved'">
              <label class="label has-text-centered">Quality of Waiver</label>
            </div>
            <div class="column is-full input-no-padding-top" v-if="profileApproval.status === 'profileapproved'">
              <div class="field">
                <p class="control is-expanded has-icons-left">
                  <ratingAndComment v-bind:textAreaPlaceholder="'Waiver rating comment'"
                                    v-bind:textAreaGuideline="''"
                                    v-bind:maxRating="5"
                                    v-bind:ratingError="profileQA.waiverQuality.rating===0"
                                    v-bind:commentError="$_.trim(profileQA.waiverQuality.comment)===''  && profileQA.waiverQuality.rating<=2"
                                    v-bind:ratingValue="profileQA.waiverQuality.rating"
                                    v-bind:ratingType="'rating'"
                                    v-on:starRating="waiverRatingStar"
                                    v-on:commentRating="waiverRatingComment"
                  ></ratingAndComment>
                </p>
              </div>
            </div>

            <div class="column is-half has-text-left label-no-padding-bottom" v-if="showFundPositionChart">
              <label class="label has-text-centered">Funding Pocket</label>
            </div>
            <div class="column is-half has-text-left label-no-padding-bottom" v-if="showFundPositionChart">
              <label class="label has-text-centered"
                     v-if="isWatsiCase">Watsi ID
              </label>
              <label class="label has-text-centered"
                     v-if="isFundManagerCase">Fund Manager approval
              </label>
            </div>
            <div class="column is-half input-no-padding-top" v-if="showFundPositionChart">
              <div class="field">
                <p class="control">
                <span class="select is-fullwidth">
                  <select v-model="profileApproval.fundingPocket"
                          v-bind:class="{'error-input':v$.profileApproval.fundingPocket.$errors.length>0}">
                    <option disabled value="">Select one</option>
                    <option value="watsi">Watsi</option>
                    <option value="contingencyfund">AMH Contingency</option>
                    <option value="amhecs">AMH ECS</option>
                    <option value="amhsvd">AMH SVD</option>
                    <option value="amhother">AMH Other</option>
                  </select>
                </span>
                </p>
              </div>
            </div>
            <div class="column is-half input-no-padding-top" v-if="isWatsiCase">
              <div class="field">
                <p class="control is-expanded has-icons-left">
                  <input class="input input-no-top-margin" type="text" placeholder="Name"
                         v-bind:class="{'error-input':v$.profileApproval.fundingPocketWatsi.$errors.length>0}"
                         v-model="profileApproval.fundingPocketWatsi">
                  <span class="icon is-small is-left">
                  <font-awesome-icon :icon="['fas', 'user-check']"/>
                </span>
                </p>
              </div>
            </div>
            <div class="column is-half input-no-padding-top" v-if="isFundManagerCase">
              <div class="field">
                <p class="control">
                <span class="select is-fullwidth">
                  <select v-model="profileApproval.fundingPocketFundManagerApproved"
                          v-bind:class="{'error-input':v$.profileApproval.fundingPocketFundManagerApproved.$errors.length>0}">
                    <option disabled value="">Select one</option>
                    <option value="fundmanagerappproved">Yes</option>
                    <option value="fundmanagernotappproved">No</option>
                  </select>
                </span>
                </p>
              </div>
            </div>


            <div class="column is-full has-text-left label-no-padding-bottom" v-if="showFundPositionChart">
              <label class="label has-text-centered">Funds Position</label>
            </div>
            <div class="column is-full input-no-padding-top" id="fundPositionChart" v-if="showFundPositionChart">
              <span v-if="showLoadingAnimation">Loading...</span>
            </div>


            <div class="column is-full has-text-centered label-no-padding-bottom" v-if="profileApproval.status !== ''">
              <label class="label has-text-centered">Approval Remarks</label>
            </div>
            <div class="column is-full input-no-padding-top" v-if="profileApproval.status !== ''">
              <textarea class="textarea" v-bind:placeholder="approvalRemarksPlaceHolder"
                        v-on:keyup="resize('noApprovalReason')"
                        v-bind:class="{'error-input':v$.profileApproval.reason.$errors.length>0}"
                        ref="noApprovalReason"
                        v-model.trim="profileApproval.reason"></textarea>
            </div>

            <div class="column is-full has-text-centered label-no-padding-bottom"
                 v-if="profileApproval.status === 'profileapproved'">
              <label class="label has-text-centered">Tag Profile For future Use</label>
            </div>
            <div class="column is-full" v-if="profileApproval.status === 'profileapproved'">
              <div class="fancy-input-group columns is-multiline is-mobile is-vcentered"
                   v-bind:class="{'error-input':v$.profileApproval.tagForFuture.$errors.length>0}">
                <input type="radio" name="taggingstatus" id="taggingyes" value="taggingyes"
                       class="fancy-input"
                       v-model="profileApproval.tagForFuture"/>
                <label for="taggingyes"
                       class="fancy-input-label column no-wrapping-label">Yes</label>
                <input type="radio" name="taggingstatus" id="taggingno" value="taggingno"
                       class="fancy-input" v-model="profileApproval.tagForFuture"/>
                <label for="taggingno" class="fancy-input-label column no-wrapping-label">No</label>
              </div>
            </div>

            <div class="column is-full"></div>
            <div class="column is-full" v-if="v$.$errors.length">
              <div id="AttachmentsSeven"
                   class="columns is-multiline is-mobile is-vcentered section-box section-box-errors">
                <div class="column is-full section-box-title-column">
                  <div class="section-box-title-text section-box-title-text-error">All Errors & Notices</div>
                </div>
                <div class="column is-full">
                  <p class="has-text-left"
                     v-for="error of v$.$errors"
                     :key="error.$uid"
                  ><strong class="strong-text-error">{{ error.$message }}</strong>
                  </p>
                </div>
              </div>
            </div>
            <div class="column is-full" v-if="v$.$errors.length"></div>


            <div class="column is-full"></div>
            <div class="column is-full">
              <button class="button is-fullwidth is-info" v-on:click="processApproval()"
                      v-bind:disabled="disableQASaving">Submit
              </button>
            </div>
          </div>
        </div>

        <div class="column is-full"></div>
      </div>
    </div>
  </div>
  <div class="profile-form-container center-screen" v-if="profileSubmitted && !profileLoading">

    <div class="columns is-multiline is-vcentered">
      <div class="column is-full">
        <a href="#" target="_blank" class="thumb fa fa-thumbs-up"></a>
        <div class="circle-wrap">
          <div class="circle-lg"></div>
        </div>
        <div class="dots-wrap">
          <div class="dot dot--t"></div>
          <div class="dot dot--tr"></div>
          <div class="dot dot--br"></div>
          <div class="dot dot--b"></div>
          <div class="dot dot--bl"></div>
          <div class="dot dot--tl"></div>
        </div>
      </div>
      <div class="column is-full" v-html="profileSubmittedMsg" style="margin-top: 60px"></div>
      <div class="column is-full">
        <button class='button is-fullwidth' v-on:click="closeProfileForm">OK</button>
      </div>
    </div>

    <!--    <span v-html="profileSubmittedMsg"></span>-->
    <!--    <br>-->
    <!--    <button class='button is-fullwidth' v-on:click="closeProfileForm">OK</button>-->
  </div>
  <div class="profile-form-container" v-if="profileLoading">
    {{ profileLoadingText }}
  </div>
</template>

<style>

.black-border {
  border: 2px solid black !important;
}

.left-side-table-cell {
  border-right: 1px solid hsl(0, 0%, 86%) !important;
}

.right-side-table-cell {
  border-left: 1px solid hsl(0, 0%, 86%) !important;
}

.middle-table-cell {
  border-right: 1px solid hsl(0, 0%, 86%) !important;
  border-left: 1px solid hsl(0, 0%, 86%) !important;
}

.non-breaking-text {
  white-space: nowrap;
}

.safe-ask-amount {
  font-weight: bold;
  color: #4d9041;
  font-size: xx-large;
}

.full-width-cell-last {
  border-width: 0 0 0 0;
  border-color: black;
  border-style: solid;
}

.section-box {
  border: 1px solid black;
  padding: 5px;
  border-radius: 10px;
}

.section-box-errors {
  border-color: red !important;
}

.section-box-title-column {
  position: relative;
  top: -18px;
  padding: 0 !important;
  margin: 0 !important;
}

.section-box-title-text {
  background-color: white;
  padding: 0 5px;
  width: max-content;
  margin: 0 10px;
  border-radius: 5px;
}

.section-box-title-text-error {
  color: red !important;
}

.label-no-padding-bottom {
  padding-bottom: 0 !important;
}

.label-no-padding-top {
  padding-top: 0 !important;
}

.profile-form-container {
  padding: 20px;
}

.center-screen {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -50px;
  margin-left: -250px;
  width: 500px;
  height: 100px;
}

.image-relative-container {
  padding: 10px;
  position: relative;
}

.image-flex-container {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
}

.full-width-div {
  width: 100%;
}

.can-scroll-content {
  overflow-x: scroll;
}

.zoom-image img {
  -webkit-transition: all 0s ease;
  -moz-transition: all 0s ease;
  -o-transition: all 0s ease;
  -ms-transition: all 0s ease;
  transition: all 0s ease;
}

.zoom-image:hover img {
  -webkit-transform: scale(5);
  -moz-transform: scale(5);
  -ms-transform: scale(5);
  -o-transform: scale(5);
  transform: scale(5);
}


</style>
